import { render, staticRenderFns } from "./AddHospitalSubSpecialites.vue?vue&type=template&id=21d42c1e"
import script from "./AddHospitalSubSpecialites.vue?vue&type=script&lang=js"
export * from "./AddHospitalSubSpecialites.vue?vue&type=script&lang=js"
import style0 from "./AddHospitalSubSpecialites.vue?vue&type=style&index=0&id=21d42c1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports